/**
 =========================================================
 * Material Dashboard 2 React - v2.2.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-react
 * Copyright 2023 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

import * as React from 'react';

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

import MDInput from "../../../components/MDInput";
import DashboardNavbar from "../../../examples/Navbars/DashboardNavbar";
import DashboardLayout from "../../../examples/LayoutContainers/DashboardLayout";
import { FormControl, InputLabel, Select } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import { useEffect, useRef, useState } from "react";
import useApi from "../../../components/Utils/api";
import MDButton from "../../../components/MDButton";
import toast from "react-hot-toast";
import RoleSection from "./RoleSection";
import PermissionControl from "../../../components/Utils/PermissionControl";


// function RolesConfiguration() {
//   const [rolesConfig, setRolesConfig] = useState(null);
//   const formRef = useRef();
//   const api = useApi();

// const convertRolesArrayToObject = (obj) => {
//   const result = {};
//   if (!obj || typeof obj !== "object") return result;

//   for (let key in obj) {
//     if (!Object.prototype.hasOwnProperty.call(obj, key)) continue;

//     // support both "Module-Sub-Id" and "Module:Sub"
//     const parts = key.includes("-") ? key.split("-") : key.split(":");
//     const module = parts[0] || "";
//     const sub = parts[1] || "";
//     const id = parts[2] || "";

//     if (!result[module]) result[module] = [];
//     result[module].push([sub, id, obj[key]]);
//   }
//   return result;
// };

//   useEffect(() => {
//     console.log("Role Config", rolesConfig);
//   },[rolesConfig])

//   const getRolesConfig = (userLevel) => {
//     const data = { usrLvlCode: userLevel };
//     api
//       .post("auth/admin/getUserLevelPermissions", data)
//       .then((response) => {
//         if (response.data.statusCodeValue === 200) {
//           setUserLevelParams(response.data.body);
//           const roleConfigObj = convertRolesArrayToObject(response.data.body);
//           setRolesConfig({
//             config: roleConfigObj[0],
//             usrLvlCode: userLevel,
//           });
//         }
//       })
//       .catch((error) => {
//         if (error.response && error.response.status === 403) {
//           toast.error("You do not have permission to perform this action.");
//           return;
//         }
//       });
//   }


//   const saveUserLevelParams = (form) => {
//     form.preventDefault();
//     const formEntries = new FormData(formRef.current).entries();
//     const formDataObject = Object.fromEntries(formEntries);
//     let duplicateFormDataObj = {
//       usrLvlCode : formDataObject.usrLvlCode
//     };
//     delete formDataObject.usrLvlCode;
//     duplicateFormDataObj.permissions = formDataObject;
//     api
//       .post("auth/admin/updateUserLevelPermissions", duplicateFormDataObj)
//       .then((response) => {
//         if (response.data.statusCodeValue === 200) {
//           toast.success(response.data.body.message);
//         }
//       })
//       .catch((error) => {
//         if (error.response.data.errors.length) {
//           error.response.data.errors.map((er) => toast.error(er));
//         }
//       });
//   }

//   return (
//     <DashboardLayout>
//       <DashboardNavbar />
//       <MDBox mt={6} mb={3}>
//         <Grid container spacing={3}>
//           <Grid mt={3} mb={3} padding={2} width={'100%'}>
//             <MDBox component="form" role="form" ref={formRef} onSubmit={(form) => saveUserLevelParams(form)} >
//               <Grid container spacing={2} >
//                 <Grid item xs={12} md={12} lg={12} justifyContent="center">
//                   <FormControl style={{height: '2.8rem', width: '13rem', display: 'block', margin: 'auto'}} >
//                     <InputLabel id="demo-simple-select-label">Select User Level</InputLabel>
//                     <Select
//                       labelId="demo-simple-select-label"
//                       id="demo-simple-select"
//                       label="Select User Level"
//                       fullWidth
//                       style={{height: '100%'}}
//                       value={rolesConfig.usrLvlCode || ''}
//                       name="usrLvlCode"
//                       onChange={(e) => getRolesConfig(e.target.value)}
//                     >
//                       <MenuItem value=""> -Select user level-</MenuItem>
//                       <MenuItem value="MAKER">Maker</MenuItem>
//                       <MenuItem value="G_MAKER">Guest Maker</MenuItem>
//                       <MenuItem value="MERCHANT">Merchant</MenuItem>
//                       <MenuItem value="REFERRALID">Merchant Group</MenuItem>
// 					  <MenuItem value="SUPERADMIN">Super Admin</MenuItem>
//                     </Select>
//                   </FormControl>
//                 </Grid>
//                 {rolesConfig && Object.keys(rolesConfig.config).map(key => (<RoleSection roleSection={rolesConfig.config[key]} sectionName={key} key={key}/>))}

//                 {rolesConfig &&
//                     <PermissionControl permission={{ restrict: true, module: "Permission", subModule: "Update" }}>
//                       <Grid item xs={12} md={12} lg={12} >
//                         <MDButton type="submit" variant="gradient" color="info" style={{float : 'right'}}>
//                           update
//                         </MDButton>
//                       </Grid>
//                     </PermissionControl>
//                 }

//               </Grid>
//             </MDBox>
//           </Grid>
//         </Grid>
//       </MDBox>
//     </DashboardLayout>
//   );
// }


// export default RolesConfiguration;


function RolesConfiguration() {
  const [rolesConfig, setRolesConfig] = useState(null);
  const formRef = useRef();
  const api = useApi();

  const convertRolesArrayToObject = (obj) => {
    const result = {};
    if (!obj || typeof obj !== "object") return result;

    for (let key in obj) {
      if (!Object.prototype.hasOwnProperty.call(obj, key)) continue;

      // support both "Module-Sub-Id" and "Module:Sub"
      const parts = key.includes("-") ? key.split("-") : key.split(":");
      const module = parts[0] || "";
      const sub = parts[1] || "";
      const id = parts[2] || "";

      if (!result[module]) result[module] = [];
      result[module].push([sub, id, obj[key]]);
    }
    return result;
  };

  useEffect(() => {
    // Debug: see what gets rendered
    console.log("[rolesConfig]", rolesConfig);
  }, [rolesConfig]);

  const getRolesConfig = (userLevel) => {
    const payload = { usrLvlCode: userLevel };

    api
      .post("auth/admin/getUserLevelPermissions", payload)
      .then((response) => {
        const ok =
          response?.status === 200 ||
          response?.data?.statusCodeValue === 200 ||
          response?.data?.statusCode === 200;

        if (!ok) return;

        const body =
          response?.data?.body ?? response?.data?.data ?? response?.data ?? {};

        // Helpful while wiring:
        console.log("[getUserLevelPermissions] body:", body);

        const cfg = convertRolesArrayToObject(body);
        setRolesConfig({
          config: cfg,
          usrLvlCode: userLevel,
        });
      })
      .catch((error) => {
        if (error?.response?.status === 403) {
          toast.error("You do not have permission to perform this action.");
        } else {
          toast.error("Failed to load permissions.");
        }
        console.error("[getUserLevelPermissions] error:", error);
      });
  };

  const saveUserLevelParams = (form) => {
    form.preventDefault();

    const formEntries = new FormData(formRef.current).entries();
    const formDataObject = Object.fromEntries(formEntries);

    const payload = {
      usrLvlCode: formDataObject.usrLvlCode,
      permissions: {},
    };

    // remove usrLvlCode from permissions mapping
    Object.keys(formDataObject).forEach((k) => {
      if (k === "usrLvlCode") return;
      payload.permissions[k] = formDataObject[k];
    });

    api
      .post("auth/admin/updateUserLevelPermissions", payload)
      .then((response) => {
        const ok =
          response?.status === 200 ||
          response?.data?.statusCodeValue === 200 ||
          response?.data?.statusCode === 200;

        if (ok) {
          const message =
            response?.data?.body?.message ||
            response?.data?.message ||
            "Updated successfully";
          toast.success(message);
        }
      })
      .catch((error) => {
        const errs = error?.response?.data?.errors;
        if (Array.isArray(errs) && errs.length) {
          errs.forEach((er) => toast.error(er));
        } else {
          toast.error("Failed to update permissions.");
        }
        console.error("[updateUserLevelPermissions] error:", error);
      });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={6} mb={3}>
        <Grid container spacing={3}>
          <Grid mt={3} mb={3} padding={2} width={"100%"}>
            <MDBox component="form" role="form" ref={formRef} onSubmit={saveUserLevelParams}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={12} lg={12} justifyContent="center">
                  <FormControl
                    style={{ height: "2.8rem", width: "13rem", display: "block", margin: "auto" }}
                  >
                    <InputLabel id="user-level-select-label">Select User Level</InputLabel>
                    <Select
                      labelId="user-level-select-label"
                      id="user-level-select"
                      label="Select User Level"
                      fullWidth
                      style={{ height: "100%" }}
                      value={rolesConfig?.usrLvlCode || ""}
                      name="usrLvlCode"
                      onChange={(e) => {
                        const code = e.target.value;
                        // immediately reflect selection in the UI
                        setRolesConfig((prev) => ({ ...(prev || {}), usrLvlCode: code }));
                        // fetch config from backend
                        getRolesConfig(code);
                      }}
                    >
                      <MenuItem value="">- Select user level -</MenuItem>
                      {/* <MenuItem value="MAKER">Maker</MenuItem> */}
                      <MenuItem value="ADMIN">Admin</MenuItem>
                      <MenuItem value="G_ADMIN">Guest Admin</MenuItem>
                      {/* <MenuItem value="MERCHANT">Merchant</MenuItem>
                      <MenuItem value="REFERRALID">Merchant Group</MenuItem> */}
                      <MenuItem value="SUPERADMIN">Super Admin</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                {/* Sections */}
                {rolesConfig?.config && Object.keys(rolesConfig.config).length > 0 ? (
                  Object.keys(rolesConfig.config).map((key) => (
                    <RoleSection
                      roleSection={rolesConfig.config[key]}
                      sectionName={key}
                      key={key}
                    />
                  ))
                ) : (
                  <Grid item xs={12} md={12} lg={12}>
                    <MDBox mt={3} textAlign="center" style={{ color: "bold" }}>
                      Select a user level to view permissions.
                    </MDBox>
                  </Grid>
                )}

                {/* Save button guarded by permission */}
                {rolesConfig && (
                  <PermissionControl
                    permission={{ restrict: true, module: "Permission", subModule: "Update" }}
                  >
                    <Grid item xs={12} md={12} lg={12}>
                      <MDButton
                        type="submit"
                        variant="gradient"
                        color="info"
                        style={{ float: "right" }}
                      >
                        update
                      </MDButton>
                    </Grid>
                  </PermissionControl>
                )}
              </Grid>
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default RolesConfiguration;

